export const resolveAppointmentAddonCost = (service = {}) => {
  const prices = Array.isArray(service.serviceprice) ? service.serviceprice : [];
  if (prices.length !== 1) return "";

  const amount = Number(prices[0] && prices[0].add_on_price);
  return Number.isFinite(amount) && amount >= 0 ? amount.toFixed(2) : "";
};

export const resolveAppointmentAdditionalServiceCost = (service = {}) => {
  const prices = Array.isArray(service.serviceprice) ? service.serviceprice : [];
  if (prices.length !== 1) return "";

  const rawAmount = prices[0] && prices[0].price;
  if (rawAmount === undefined || rawAmount === null || String(rawAmount).trim() === "") return "";

  const amount = Number(rawAmount);
  return Number.isFinite(amount) && amount >= 0 ? amount.toFixed(2) : "";
};
